import { render } from "./PantryStockNotificationDialog.vue?vue&type=template&id=35c32169&ts=true"
import script from "./PantryStockNotificationDialog.vue?vue&type=script&lang=ts"
export * from "./PantryStockNotificationDialog.vue?vue&type=script&lang=ts"

import "./PantryStockNotificationDialog.vue?vue&type=style&index=0&id=35c32169&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__